import React from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

// Centered spinner for a whole page/section waiting on one big fetch (e.g. a
// college's full detail payload), where a skeleton would have to guess at a
// layout instead of matching a grid of already-known cards.
const PageLoader = ({ label = "Loading…", className = "" }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.2 }}
    className={"flex flex-col items-center justify-center gap-3 py-24 text-slate-500 " + className}
  >
    <motion.div animate={{ rotate: 360 }} transition={{ duration: 0.9, repeat: Infinity, ease: "linear" }}>
      <Loader2 className="h-8 w-8 text-brand-600" />
    </motion.div>
    <div className="text-sm font-medium">{label}</div>
  </motion.div>
);

export default PageLoader;
